import { Component, OnInit, TemplateRef, ViewChild, Input, Injectable } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { ConfirmModalTemplateComponent } from './confirm-modal-template/confirm-modal-template.component';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ngx-modale',
  templateUrl: './confirm-modale.component.html',
  styleUrls: ['./confirm-modale.component.scss']
})

export class ConfirmModaleComponent implements OnInit {

  @Input() titolo: any;
  @Input() messaggio: any;
  private response = new BehaviorSubject<boolean>(null);

  constructor(private dialogService: NbDialogService, private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.messaggio= this._sanitizer.bypassSecurityTrustHtml(this.messaggio)
  }

  public confirm(titolo: any, messaggio: any): void {

    var ref = this;
    ref.response = new BehaviorSubject<boolean>(null);

    const modalRef = this.dialogService.open(
                      ConfirmModalTemplateComponent,
                      { 
                        context: {
                          title: titolo,
                          messaggio
                        },
                        closeOnBackdropClick: false

                      }
                    );
                  
    modalRef.componentRef.instance.isConfirmed().subscribe(
      ((res: boolean) => {
          ref.response.next(res);
      })
    );

  }

  public onClose():any {
    return this.response.asObservable();
  }

}
